// extracted by mini-css-extract-plugin
export var fullWidthButton = "_102-0";
export var tagInputDisabled = "_102-1";